import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import React from "react";
import useBasicProfile from "../../../../hooks/useBasicProfile";

interface IProps {
  address: string | null;
}

type Props = {
  color: string;
};

const UserNameHeader = styled.h3<Props>`
  ${({ color }) => `color: ${color};`}
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 3px;
`;

const ReferenceHeader: React.FC<IProps> = ({ address }) => {
  const { basicProfile: nextReferenceProfile } = useBasicProfile(address);
  const theme = useTheme();
  return (
    <UserNameHeader color={theme.brandColor}>
      {!!nextReferenceProfile.name && nextReferenceProfile.name != "Guest" ? nextReferenceProfile.name : address}
    </UserNameHeader>
  );
};

export default ReferenceHeader;
